<div class="nb-checkbox-group">
  <label
    class="nb-checkbox"
    v-for="option in options"
    :key="getOptionKey(option)"
    :class="{
      'is-disabled': isDisabled(option),
    }"
  >
    <input
      type="checkbox"
      :value="getOptionValue(option)"
      :checked="isChecked(option)"
      :disabled="isDisabled(option)"
      @change="toggle(option)"
    />

    <div class="nb-icon">
      <span class="iconfont-check" v-if="isChecked(option)"></span>
    </div>

    <!-- parent will provide content -->
    <div class="checkbox-content">
      <slot :option="option" :checked="isChecked(option)" :disabled="isDisabled(option)" :redeemed="isRedeemed(option)" />
    </div>
  </label>
</div>
